var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col" }, [
    _c(
      "div",
      { staticClass: "flex flex-col py-2" },
      [
        _c(
          "RouterLink",
          {
            staticClass: "flex items-center",
            class: _vm.getNameClasses,
            attrs: {
              to: {
                name: _vm.postingDetailsRouteName,
                params: { id: _vm.posting.id },
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass:
                  "text-lg font-medium cursor-pointer capitalize mb-1 text-primary-500",
              },
              [_vm._v(" " + _vm._s(_vm.posting.job_title) + " ")]
            ),
          ]
        ),
        _c("div", { staticClass: "text-storm-gray font-normal text-sm" }, [
          _c("p", { staticClass: "mt-1 mb-1" }, [
            _vm._v(
              " Created: " +
                _vm._s(
                  _vm._f("moment")(_vm.posting.created_at, "D MMM, YYYY")
                ) +
                " "
            ),
          ]),
          _c(
            "p",
            {
              staticClass: "flex gap-2 items-center capitalize",
              class: _vm.getLocationClasses,
            },
            [
              _c("LocationIcon", {
                staticClass: "h-4 w-4",
                attrs: { fill: "#000000" },
              }),
              _vm._v(" " + _vm._s(_vm.location) + " "),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "flex flex-col gap-2 cardMinHeight" },
      [
        _c("div", { staticClass: "flex items-center text-sm" }, [
          _c(
            "p",
            { staticClass: "w-36 flex items-center gap-2 titleItem" },
            [_c("UserIcon", { staticClass: "h-4 w-4" }), _vm._v(" Type ")],
            1
          ),
          _c("span", { staticClass: "text-storm-gray font-normal text-sm" }, [
            _vm._v(_vm._s(_vm.type)),
          ]),
        ]),
        _c("div", { staticClass: "flex items-center text-sm" }, [
          _c(
            "p",
            { staticClass: "w-36 flex items-center gap-2 titleItem" },
            [
              _c("DollarIcon", { staticClass: "h-4 w-4" }),
              _vm._v(" Budget/Rate "),
            ],
            1
          ),
          _c("span", { staticClass: "text-storm-gray font-normal text-sm" }, [
            _vm._v(_vm._s(_vm.getBudet || 0)),
          ]),
        ]),
        !_vm.isFullTimeJob
          ? [
              _vm.posting.start_date
                ? _c("div", { staticClass: "flex items-center text-sm" }, [
                    _c(
                      "p",
                      { staticClass: "w-36 flex items-center gap-2 titleItem" },
                      [
                        _c("Calendar", { staticClass: "h-4 w-4" }),
                        _vm._v(" Start date "),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "text-storm-gray font-normal text-sm" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.posting.start_date,
                              "MMM DD, YYYY"
                            )
                          )
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.posting.end_date
                ? _c("div", { staticClass: "flex items-center text-sm" }, [
                    _c(
                      "p",
                      { staticClass: "w-36 flex items-center gap-2 titleItem" },
                      [
                        _c("Calendar", { staticClass: "h-4 w-4" }),
                        _vm._v(" End date "),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "text-storm-gray font-normal text-sm" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.posting.end_date,
                              "MMM DD, YYYY"
                            )
                          )
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          : _vm._e(),
        _c("div", { staticClass: "flex items-center text-sm" }, [
          _c(
            "p",
            { staticClass: "w-36 flex items-center gap-2 titleItem" },
            [
              _c("ApplicatoinIcon", { staticClass: "h-4 w-4" }),
              _vm._v(" Applicants "),
            ],
            1
          ),
          _c("span", { staticClass: "text-lightGreen font-medium text-sm" }, [
            _vm._v(_vm._s(_vm.applications.length)),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "flex items-center text-sm minManagerH" },
          [
            _c(
              "p",
              { staticClass: "w-36 flex items-center gap-2 titleItem" },
              [
                _c("UserProfileIcon", { staticClass: "h-4 w-4" }),
                _vm._v(" Manager "),
              ],
              1
            ),
            _vm.manager
              ? _c(
                  "RouterLink",
                  {
                    staticClass: "max-w-full",
                    attrs: { to: _vm.managerRoute },
                  },
                  [
                    _c("div", { staticClass: "flex flex-row gap-1" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "manager-chip flex flex-row items-center text-left",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white manager-image hover:text-white hover:border-primary-500",
                              style: _vm.bgStyle,
                            },
                            [_vm._v(" " + _vm._s(_vm.initial) + " ")]
                          ),
                          _vm._v(" " + _vm._s(_vm.manager.name) + " "),
                        ]
                      ),
                    ]),
                  ]
                )
              : _c(
                  "p",
                  { staticClass: "text-storm-gray font-normal text-sm" },
                  [_vm._v("n/a")]
                ),
          ],
          1
        ),
        _c("div", { staticClass: "flex items-center text-sm mb-3" }, [
          _c(
            "p",
            { staticClass: "w-36 flex items-center gap-2 titleItem" },
            [_c("PinIcon", { staticClass: "h-4 w-4" }), _vm._v(" Posted To ")],
            1
          ),
          _vm.postedAt.length
            ? _c(
                "span",
                { staticClass: "text-lightGreen flex" },
                _vm._l(_vm.postedAt, function (item, index) {
                  return _c("ItemChip", {
                    key: index,
                    attrs: {
                      itemId: item,
                      itemName: item,
                      chipClass: index === 1 ? "b-custom_chip_class" : "",
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }